import { ListWorkOrderScheduleDto, RecurrenceType, WorkOrderScheduleDto, WorkOrderScheduleStatus } from "../models/workorderschedule.models";

export const getScheduleStatusDescription = (schedule: WorkOrderScheduleDto|ListWorkOrderScheduleDto) => {
	if (schedule.Deleted)
		return "Deleted";

	switch (schedule.Status) {
		case WorkOrderScheduleStatus.Scheduled:
			return "Scheduled";
		case WorkOrderScheduleStatus.Active:
			return "Active";
		case WorkOrderScheduleStatus.Inactive:
			return "Inactive";
		case WorkOrderScheduleStatus.Completed:
			return "Completed";
		default:
			return "Unknown";
	}
}

export const getScheduleStatusColor = (schedule: WorkOrderScheduleDto|ListWorkOrderScheduleDto) => {
	if (schedule.Deleted)
		return "red";

	switch (schedule.Status) {
		case WorkOrderScheduleStatus.Scheduled:
			return "blue";
		case WorkOrderScheduleStatus.Active:
			return "green";
		case WorkOrderScheduleStatus.Inactive:
			return "gray";
		case WorkOrderScheduleStatus.Completed:
			return "orange";
		default:
			return "gray";
	}
}

export const getRecurrenceTypeDescription = (recurrenceType: RecurrenceType) => {
	switch (recurrenceType) {
		case RecurrenceType.OneTime:
			return "One-Time";
		case RecurrenceType.Daily:
			return "Daily";
		case RecurrenceType.Weekly:
			return "Weekly";
		case RecurrenceType.Monthly:
			return "Monthly";
		default:
			return "Unknown";
	}
}